<div *ngIf="(isMobile$ | async);else inline" class="languages select-languages">
  <button class="language-button active" mat-button [matMenuTriggerFor]="menu">
    {{active | uppercase}}
  </button>

  <mat-menu [id]="'nc-language-picker-menu-' + id" #menu="matMenu">
    <button mat-menu-item *ngFor="let language of languages"
            [class.active]="active === language"
            (click)="onChange(language)"
            [id]="'nc-language-button-' + language"
            class="language-button language-center">
      {{language | uppercase}}
    </button>
  </mat-menu>
</div>

<ng-template #inline>
  <div class="languages inline-languages">
    <button *ngFor="let language of languages"
            [class.active]="active === language"
            [id]="'nc-language-button-' + language"
            (click)="onChange(language)"
            class="language-button inline-language">
      {{language | uppercase}}
    </button>
  </div>
</ng-template>

